import { createAsyncThunk } from "@reduxjs/toolkit";
import httpService from "../../utils/httpService";

export const getCurrencies = createAsyncThunk('currencies', async () => {
    const res = await httpService.get(`utils/currencies`);
    return res.data;
})